import axios from 'axios';
import { Toast } from 'mint-ui';
const TIMEOUT = 20000;
export default {
  data () {
    return {
      timeRecords: {}
    };
  },
    methods: {

    requestPut(url, params, withToken) {
        return this.requestPost(url, params, withToken, 'put');
    },       
    // axios post方法, 状态码200为请求成功，反之则失败
    requestPost (url, params, widthtoken, method='post') {
      const headers = {
        'Content-Type': 'application/json'
      };
      if (widthtoken !== false) {
        headers.Authorization = 'Bearer ' + localStorage.getItem('token'); // 用户token
      }
      const self = this;
      if (typeof self.loading === 'boolean') {
        self.loading = true;
      }
      return axios({
        method: method,
        url: url,
        headers: headers,
        data: params
      }).then((response) => {
        const SUCCESS_CODE = 200;
        console.log(response);
        if (typeof self.loading === 'boolean') {
          self.loading = false;
        }
        if (response.data.status != SUCCESS_CODE) {
          self.requestOK(response.data);
        } else {
          return Promise.resolve(response);
        }
        return Promise.reject(new Error('未知错误'));
      }).catch((err) => {
        self.requestErr(err);
        return Promise.reject(err);
      });
    },
    // axios get方法，和post方法不一样，get参数为params,post参数为data
    requestGet (url, params) {
      const headers = {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      };
      const self = this;
      if (typeof self.loading === 'boolean') {
        self.loading = true;
      }
      return axios({
        method: 'get',
        url: url,
        headers: headers,
        params: params
      }).then(function (response) {
        const SUCCESS_CODE = 200;
        if (typeof self.loading === 'boolean') {
          self.loading = false;
        }
        if (response.data.status !== SUCCESS_CODE) {
          self.requestOK(response.data);
        } else {
          return Promise.resolve(response);
        }
        return Promise.reject(new Error('未知错误'));
      }).catch(function (err) {
        self.requestErr(err);
        return Promise.reject(err);
      });
    },
    requestDelete (url, params) {
      const headers = {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      };
      const self = this;
      if (typeof self.loading === 'boolean') {
        self.loading = true;
      }
      return axios({
        method: 'delete',
        url: url,
        headers: headers,
        params: params
      }).then(function (response) {
        const SUCCESS_CODE = 200;
        if (typeof self.loading === 'boolean') {
          self.loading = false;
        }
        if (response.data.status !== SUCCESS_CODE) {
          self.requestOK(response.data);
          return Promise.reject(new Error('未知错误'));
        } else {
          return Promise.resolve(response);
        }
      }).catch(function (err) {
        self.requestErr(err);
        return Promise.reject(err);
      });
    },
    // 请求成功数据处理，例如上传文件功能
    requestOK (responseData) {
      const OTHER_LOGIN = 10007; // 多点登录
      const TOKEN_EXPIRED = 10006; // token失效
      const TOKEN_ERROR = 10005; // token失效
      const PARAM_ERROR = 10003; // 参数不对
      // const DATABASE_ERROR = 10008; // 操作数据库失败
      const status = responseData.status;
      if (status === PARAM_ERROR && this.$route.path === '/login') {
        if (this.mobile) {
          Toast('账号密码不匹配');
        } else {
          this.$message.error('账号密码不匹配');
        }
        return;
      }
      if (this.mobile) {
        Toast(responseData.message);
      } else {
        this.$message.error(responseData.message);
      }
      if (status === OTHER_LOGIN || status === TOKEN_EXPIRED || status === TOKEN_ERROR) {
        this.$router.push('/login');
      }
    },
    // 请求失败数据处理，例如上传文件功能
    requestErr (err) {
      if (typeof this.loading === 'boolean') {
        this.loading = false;
      }
      if (err.message === '未知错误') {
        return;
      }
      console.log(err);
      if (this.mobile) {
        Toast('操作失败');
      } else {
        this.$message.error('操作失败');
      }
    },
    sendMeterPostRequest(cmd, collectorNumber, meterAddress, params) {
          // 下发查询指令
          const self = this;
          // self.formData.collectorNumber = 123456789013;
          // self.formData.meterAddress = 123456787912;
          var opts = {
              cmd: cmd,
              collector_number: collectorNumber,
              meter_address: meterAddress
          }
          Object.assign(opts, params);

          return self.requestPost('/v1/energy_meter/option', opts).then(() => {
              self.timeRecords[cmd] = new Date().getTime();
              return self.delay(2000).then(function () {
                  return self.readAmmeterData(cmd, meterAddress);
              });
          });
      },    
    sendMeterRequest(cmd, collectorNumber, meterAddress, withAlipay=false) {
      // 下发查询指令
      const self = this;
      // self.formData.collectorNumber = 123456789013;
      // self.formData.meterAddress = 123456787912;
        
      var addonPath = withAlipay ? 'alipay/' : '';
        
        var path = '/v1/' + addonPath + 'energy_meter/option?cmd=' + cmd + '&collector_number=' + collectorNumber + '&meter_address=' + meterAddress;        
        return self.requestGet(path).then(() => {
            self.timeRecords[cmd] = new Date().getTime();
            return self.delay(2000).then(function(){
                return self.readAmmeterData(cmd, meterAddress, withAlipay);
            });
        });
    },
    readAmmeterData(cmd, meterAddress, withAlipay = false)  {
      const self = this;
        var addonPath = withAlipay ? 'alipay/' : '';
        var path = '/v1/' + addonPath + 'energy_meter/detail?cmd=' + cmd + '&meter_address=' + meterAddress
        return self.requestGet(path, {}).then((response) => {
        if (response && response.data && response.data.result) {
          const responseData = JSON.parse(response.data.result);
          return Promise.resolve(responseData);
        } else if (new Date().getTime() - self.timeRecords[cmd] < TIMEOUT) {
          // setTimeout(() => {
          //   self.readAmmeterData(cmd);
          // }, 1000);
          return self.delay(1000).then(function(){
              return self.readAmmeterData(cmd, meterAddress, withAlipay);
          });
        } else {
          return Promise.reject("命令超时");
        }
      });
    },
    delay(t) {   
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                resolve();
            }, t);
        });
    },       
  }
};



// WEBPACK FOOTER //
// ./src/mixins/commonMixin.js